import { Card, CardContent } from '@/components/ui/card'
import type { UserStats as UserStatsType } from '@/types'
import { formatNumber } from '@/utils/formatNumber'

interface UserStatsProps {
  stats: UserStatsType | null
}

export function UserStats({ stats }: UserStatsProps) {
  if (!stats) return null

  const statItems = [
    { label: '총 스레드', value: stats.total_threads },
    { label: '활성 스레드', value: stats.active_threads },
    { label: '총 메시지', value: stats.user_messages + stats.assistant_messages },
    { label: '사용자 메시지', value: stats.user_messages },
    { label: '어시스턴트 메시지', value: stats.assistant_messages },
    {
      label: '평균 메시지/스레드',
      value:
        stats.total_threads > 0
          ? ((stats.user_messages + stats.assistant_messages) / stats.total_threads).toFixed(1)
          : '0.0',
    },
    { label: '비활성 일수', value: stats.days_since_last_activity },
  ]

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7">
      {statItems.map((item) => (
        <Card key={item.label}>
          <CardContent className="p-4">
            <p className="text-xs text-muted-foreground">{item.label}</p>
            <p className="mt-1 text-2xl font-bold">
              {typeof item.value === 'number'
                ? formatNumber(item.value)
                : item.value}
            </p>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
